export default __webpack_public_path__ + "static/media/book.b99fa8a3.png";